import React, { useEffect } from 'react'

const TikTokEmbed = ({ videoId, videoUrl }) => {
  useEffect(() => {
    // Load TikTok embed script
    const script = document.createElement('script')
    script.src = 'https://www.tiktok.com/embed.js'
    script.async = true
    document.body.appendChild(script)

    return () => {
      // Cleanup
      if (document.body.contains(script)) {
        document.body.removeChild(script)
      }
    }
  }, [videoId])

  return (
    /* Wrapper houdt de embed binnen de container: TikTok's embed.js zet zelf min-width 325px
       op de blockquote en een vaste breedte op de iframe, waardoor hij op 360px 16px te breed was. */
    <div className="w-full max-w-full overflow-hidden [&_.tiktok-embed]:!w-full [&_.tiktok-embed]:!max-w-full [&_.tiktok-embed]:!min-w-0 [&_iframe]:!w-full [&_iframe]:!max-w-full">
    <blockquote
      className="tiktok-embed"
      cite={videoUrl}
      data-video-id={videoId}
      style={{
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        overflow: 'hidden'
      }}
    >
      {/* Placeholder tot embed.js laadt: op 360x640 vulde 600px het hele scherm met zwart */}
      <section style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'min(600px, 80vh)',
        background: 'black'
      }}>
        <a 
          target="_blank" 
          rel="noopener noreferrer"
          href={videoUrl}
          style={{ 
            color: 'white',
            textDecoration: 'none',
            padding: '20px',
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '10px',
            backdropFilter: 'blur(10px)'
          }}
        >
          Bekijk video op TikTok →
        </a>
      </section>
    </blockquote>
    </div>
  )
}

export default TikTokEmbed